import styled from "styled-components";

export const StyledPendingPayoutBox = styled.div`
  padding: 3.2rem 2.4rem;
  background-color: #eae6f3;
  border: 1px solid #43375d;
  border-radius: 5px;
  max-width: 33rem;
  width: 100%;

  .text-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    .heading-text {
      color: #272037;
      font-size: 1.8rem;
    }
    .value-text {
      color: #272037;
      font-size: 2.4rem;
      font-weight: 700;
    }
  }
`;
